// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"4b1f9a53","453":"d09ddd63"}[chunkId] + ".chunk.js";
};